module.exports = __webpack_public_path__ + "img/icon-presentation.a316db1a.svg";